export default class InfoBarHeader extends React.Component {
    constructor(props) {
      super(props);
      this.getDateTime = this.getDateTime.bind(this);
      this.formatChangeLog = this.formatChangeLog.bind(this);
      this.formatObjectSourceInfo = this.formatObjectSourceInfo.bind(this);
      this.formatSourceObjectNotes = this.formatSourceObjectNotes.bind(this);
      this.dataForObjectOrSource = this.dataForObjectOrSource.bind(this);
      this.slideInfoBar = this.slideInfoBar.bind(this);
      this.generateEditForm = this.generateEditForm.bind(this);
      this.domId = "infobar-header-menu";
      this.dataI18nKeys = {
        new_value: "source-new-value",
        old_value: "source-old-value",
        fields: "source-fields",
        event: "source-event",
        time: "source-time",
        date: "source-date",
        change_log: "source-change-log",
        edit: "source-edit",
        delete: "source-delete",
        info: "source-info",
        reference: "source-reference",
        about_the_object: "source-about-the-object",
        source_data: "source-source-data",
        object_data: "source-object-data",
        nothing_to_show: "source-nothing-to-show",
        save_as_favorite: "source-save-as-favorite",
        saved_as_favorite: "source-saved-as-favorite",
      };
      this.state = {
        column: null,
        data: [],
        changeLogData: [],
        direction: null,
      }
    }
   
  
    componentDidMount() {    
      // $('#infobar-header > div:visible:last').addClass('last-visible-div');
      $('.ui.dropdown').dropdown(); 
      this.slideInfoBar();
      if(this.props.changeLog && this.props.changeLog != this.state.data){
        let changeLogDataArr = [];
        for(var i=0; i<this.props.changeLog.length; i++){
          // if(i==1){
          //   continue;
          // }else{ 
          if(this.props.changeLog[i].fields != null){
            if(this.props.changeLog[i].fields.length > 0){
              for(var j=0; j < this.props.changeLog[i].fields.length; j++){  
                if(this.props.changeLog[i].fields[j].name == 'Highlight Height' || this.props.changeLog[i].fields[j].name == 'Published By'){
                  continue;
                }else{        
                changeLogDataArr.push({
                  "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
                  "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
                  "event" : this.props.changeLog[i].command,
                  "fields" : this.props.changeLog[i].fields[j].name,
                  "old_value" : this.props.changeLog[i].fields[j].old_value,
                  "new_value" : this.props.changeLog[i].fields[j].new_value
                });
                }
              }
              }
            }else{
              changeLogDataArr.push({
                "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
                "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
                "event" : this.props.changeLog[i].command,
                "fields" : '-',
                "old_value" : '-',
                "new_value" : '-'
              });
            }
          // }
        }
        this.setState({
          data: this.props.changeLog,
          changeLogData: changeLogDataArr
        });
      }
      // to show edit form in mobile view when click on edit button
      if(screen.width < 700){
      $('div#object-form-container').sidebar('attach events','div.editOptionInMenu','show'); 
      }
    }
  
    componentDidUpdate(prevProps, prevState, snapshot) {
      if(this.props.changeLog && this.props.changeLog != this.state.data){
        let changeLogDataArr = [];
        for(var i=0; i<this.props.changeLog.length; i++){
          // if(i==1){
          //   continue;
          // }else{ 
          if(this.props.changeLog[i].fields != null){
            if(this.props.changeLog[i].fields.length > 0){
              for(var j=0; j < this.props.changeLog[i].fields.length; j++){  
                if(this.props.changeLog[i].fields[j].name == 'Highlight Height' || this.props.changeLog[i].fields[j].name == 'Published By'){
                  continue;
                }else{        
                changeLogDataArr.push({
                  "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
                  "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
                  "event" : this.props.changeLog[i].command,
                  "fields" : this.props.changeLog[i].fields[j].name,
                  "old_value" : this.props.changeLog[i].fields[j].old_value,
                  "new_value" : this.props.changeLog[i].fields[j].new_value
                });
                }
              }
              }
            }else{
              changeLogDataArr.push({
                "date" : this.getDateTime(this.props.changeLog[i].firedAt, "d"),
                "time" : this.getDateTime(this.props.changeLog[i].firedAt, "t"),
                "event" : this.props.changeLog[i].command,
                "fields" : '-',
                "old_value" : '-',
                "new_value" : '-'
              });
            }
          // }
        }
        this.setState({
          data: this.props.changeLog,
          changeLogData: changeLogDataArr
        });
      }
      var str = $('.ui.dropdown.testClass').attr("class");
      if(str.includes('upward') == true){ $('.ui.dropdown.testClass').removeClass("upward") }
      this.slideInfoBar();
    }
  
    slideInfoBar() {
      // if (this.props.selectedObject) {
      //   $("#" + this.domId).slideDown("slow");
      // } else {
      //   $("#" + this.domId).slideUp("slow");
      // }
    }
  
    getDateTime(timestamp, format = "dt") {
      var d = new Date(timestamp);
      var addLeadingZero = (val) => (val < 10 ? "0" : "") + val;
      if (/^d$/.test(format)) {
        return (
          d.getFullYear() +
          "-" +
          addLeadingZero(d.getMonth() + 1) +
          "-" +
          addLeadingZero(d.getDate())
        );
      } else if (/^t$/.test(format)) {
        return (
          addLeadingZero(d.getHours()) +
          ":" +
          addLeadingZero(d.getMinutes()) +
          ":" +
          addLeadingZero(d.getSeconds())
        );
      }
      return (
        d.getFullYear() +
        "-" +
        addLeadingZero(d.getMonth() + 1) +
        "-" +
        addLeadingZero(d.getDate()) +
        " " +
        addLeadingZero(d.getHours()) +
        ":" +
        addLeadingZero(d.getMinutes())
      );
    }
  
  
    handleSort (clickedColumn) {
      var changeLogText = globalFunctions.getTranslatedMessage(
        this.dataI18nKeys.change_log,
        "Change Log"
      ) + ' - '+ this.props.selectedObject.viewId;
      const { column, data, direction, changeLogData } = this.state;
      if (column !== clickedColumn) {
        this.setState({
          column: clickedColumn,
          changeLogData: _.orderBy(changeLogData, [log => log[clickedColumn].toString().toLowerCase()], ['asc']),
          direction: 'ascending',
        }, () => { this.props.showModal(changeLogText, this.formatChangeLog())})
      }else{
        this.setState({
          changeLogData: _.orderBy(changeLogData, [log => log[clickedColumn].toString().toLowerCase()], [direction === 'ascending'? 'desc' : 'asc']),
          direction: direction === 'ascending' ? 'descending' : 'ascending',
        }, () => { this.props.showModal(changeLogText, this.formatChangeLog()) });
      }    
    }
    formatChangeLog() {
      var changeLog = this.props.changeLog;
      const { column, data, direction, changeLogData } = this.state; 
      
      if (changeLog.length === 0) {
        return (
          <h1 id="no-log-message">
            {globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.nothing_to_show,
              "Nothing to show"
            )}
          </h1>
        );
      }
      return (
        <div>
          <table className="ui sortable celled table change-log">
            <thead>
              <tr>
                <th 
                className={column === 'date' ? "sorted "+direction : null}
                sorted={column === 'date' ? direction : null}
                onClick={(e) => this.handleSort('date')}>
                  <span data-i18n={this.dataI18nKeys.date}>Date</span>
                </th>
                <th
                className={column === 'time' ? "sorted "+direction : null}
                sorted={column === 'time' ? direction : null}
                onClick={(e) => this.handleSort('time')}>
                  <span data-i18n={this.dataI18nKeys.time}>Time (UTC)</span>
                </th>
                <th
                className={column === 'event' ? "sorted "+direction : null}
                sorted={column === 'event' ? direction : null}
                onClick={(e) => this.handleSort('event')}>
                  <span data-i18n={this.dataI18nKeys.event}>Event</span>
                </th>
                <th
                className={column === 'fields' ? "sorted "+direction : null}
                sorted={column === 'fields' ? direction : null}
                onClick={(e) => this.handleSort('fields')}>
                  <span data-i18n={this.dataI18nKeys.fields}>Fields</span>
                </th>
                <th 
                className={column === 'old_value' ? "width-20 sorted "+direction : "width-20"}
                sorted={column === 'old_value' ? direction : null}
                onClick={(e) => this.handleSort('old_value')}>
                  <span data-i18n={this.dataI18nKeys.old_value}>Old value</span>
                </th>
                <th 
                className={column === 'new_value' ? "width-20 sorted "+direction : "width-20"}
                sorted={column === 'new_value' ? direction : null}
                onClick={(e) => this.handleSort('new_value')}>
                  <span data-i18n={this.dataI18nKeys.new_value}>New value</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {changeLogData.map((log, index) => {
                // if (log.fields && log.fields.length > 0) {
                //   return log.fields.map((field, i) => {
                //     if (typeof field === "undefined") {
                //       return null;
                //     }
                //     return (
                //       <tr key={"index-" + index + "-" + i}>
                //         <td>{this.getDateTime(log.firedAt, "d")}</td>
                //         <td>{this.getDateTime(log.firedAt, "t")}</td>
                //         <td>{log.command}</td>
                //         <td>{field.name}</td>
                //         <td style={{textTransform:'capitalize'}}>
                //           {field.old_value && String(field.old_value).length > 0
                //             ? field.old_value
                //             : "-"}
                //         </td>
                //         <td style={{textTransform:'capitalize'}}>
                //           {field.new_value && String(field.new_value).length > 0
                //             ? field.new_value
                //             : "-"}
                //         </td>
                //       </tr>
                //     );
                //   });
                // }
                // return (
                //   <tr key={"index-" + index}>
                //     <td>{this.getDateTime(log.firedAt, "d")}</td>
                //     <td>{this.getDateTime(log.firedAt, "t")}</td>
                //     <td>{log.command}</td>
                //     <td>-</td>
                //     <td>-</td>
                //     <td>-</td>
                //   </tr>
                // );
                if(typeof log.old_value == 'object'){
                  var logOldVal = log.old_value;
                  var oldAuthName = new Array();
                  for(var key1 in logOldVal){
                  for (var key2 in logOldVal[key1])
                  {
                    if(key2 == 'author_firstname'){
                      var fName = logOldVal[key1][key2];
                    }
                    if(key2 == 'author_lastname'){
                      var lName = logOldVal[key1][key2];
                    }
                  }
                  oldAuthName.push(fName+' '+lName+'\n');
                  }
                  var oldNametemp = oldAuthName.toString();
                  var oldNametemp2 = oldNametemp.split(',');
                }

                if(typeof log.new_value == 'object'){
                  var logNewVal = log.new_value;
                  var newAuthName = new Array();
                  for(var key1 in logNewVal){
                  for (var key2 in logNewVal[key1])
                  {
                    if(key2 == 'author_firstname'){
                      var fName = logNewVal[key1][key2];
                    }
                    if(key2 == 'author_lastname'){
                      var lName = logNewVal[key1][key2];
                    }
                  }
                  newAuthName.push(fName+' '+lName+'\n');
                  }
                  var newNametemp = newAuthName.toString();
                  var newNametemp2 = newNametemp.split(',');
                }
                return (
                  <tr key={"index-" + index}>
                    <td>{log.date}</td>
                    <td>{log.time}</td>
                    <td>{log.event}</td>
                    <td>{log.fields}</td>
                    <td className="changeLogOld" style={{whiteSpace: 'pre-wrap'}}>{typeof log.old_value == 'object' ? oldNametemp2 : log.old_value}</td>
                    <td className="changeLogNew" style={{whiteSpace: 'pre-wrap'}}>{typeof log.new_value == 'object' ? newNametemp2 : log.new_value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
  
    dataForObjectOrSource() {
      if (this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT) {
        return {
          obj1: this.props.objectInfo.actualObjectData,
          obj2: this.props.objectInfo.objectData,
        };
      }
      if (this.props.objectInfo.type === globalFunctions.objectTypes.SOURCE) {
        return {
          obj1: this.props.objectInfo.sourceData,
          obj2: this.props.objectInfo.reference,
        };
      }
      return { obj1: {}, obj2: {} };
    }
  
    generateTinyURL(id) {
      globalFunctions.displayTinyUrl(site_url + "/" + id);
    }
  
    generateEditForm() {
      console.log(2770);
      // console.log(this.props);
    }
  
    copyToClipboard(id) {
      var $temp = $("<input>");
      $("body").append($temp);
      // $temp.val(site_url + "/" + id).select();
      $temp.val(id).select();
      document.execCommand("copy");
      $temp.remove();
    }
  
    
        
  openNavHeader() {
    var selectedSourceType = document.getElementById('selected_source_type_hidden').value;
    var editElement = document.getElementById("selected-object-hide-id_Edit");
    if (selectedSourceType == 'REFERENCE') {    
      if (editElement !== null) { editElement.style.display = "none"; }
      document.getElementById('selected-object-hide-id_Notes').style.display = "none";
      document.getElementById("selected-object-hide-id_ChangeLog").style.display = "none";
    } 
    if (selectedSourceType == 'REFERENCE_NO') {  
      document.getElementById('selected-object-hide-id_Notes').style.display = "none";
      if (editElement !== null) { editElement.style.display = "block";}
      document.getElementById("selected-object-hide-id_ChangeLog").style.display = "block";
    } 
    if (selectedSourceType == 'OBJECT') {    
      if (editElement !== null) { editElement.style.display = "block";}
      document.getElementById('selected-object-hide-id_Notes').style.display = "block";
      document.getElementById("selected-object-hide-id_ChangeLog").style.display = "block";
      document.getElementById('selected-object-hide-id_Notes').innerHTML= 'Info';
      var isNotesDisabled = document.getElementById('selected-object-id_Notes').getElementsByTagName('span')[0].classList.contains('disabled');
      if (isNotesDisabled) {
        document.getElementById('selected-object-hide-id_Notes').classList.add("disabled");
      }
    } 
    if (selectedSourceType == 'SOURCE') {
      if (editElement !== null) { editElement.style.display = "block"; }
      document.getElementById('selected-object-id_Info').style.display = "block";
      document.getElementById('selected-object-hide-id_Notes').style.display = "block";
      document.getElementById("selected-object-hide-id_ChangeLog").style.display = "block";
      document.getElementById('selected-object-hide-id_Notes').innerHTML= 'Notes';    
      var isNotesDisabled = document.getElementById('selected-object-id_Notes').getElementsByTagName('span')[0].classList.contains('disabled');
      if (isNotesDisabled) {
        document.getElementById('selected-object-hide-id_Notes').classList.add("disabled");
      }
    }
    if (selectedSourceType !== 'REFERENCE') {
      var isChangeLogDisabled = document.getElementById('selected-object-id_ChangeLog').getElementsByTagName('span')[0].classList.contains('disabled');
      if (isChangeLogDisabled) {
        document.getElementById('selected-object-hide-id_ChangeLog').classList.add("disabled");
      }
    }
    document.getElementById("mySidenav2").style.width = "250px";
    document.getElementById("content-main").classList.add("sidebar-open");
    document.getElementById('header-dropdown-icon').style.backgroundColor = "grey";
    document.getElementById('header-dropdown-icon').style.opacity = 0.8;
    document.cookie = "_menustatus=open;path=/";   
    let ele = document.getElementById("menu-dropdown").style.display = "none";
    $(ele).parent().hide();
    let searchBar = document.querySelector(".search.container .ui.icon.input");
     searchBar.style.marginLeft = "200px";
  }
  
    formatObjectSourceInfo() {
      const object = this.props.objectInfo;
      // console.log(object);
      // console.log(this.props.selectedObject);
      const message1 =
        this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
          ? globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.about_the_object,
              "About the object"
            )
          : globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.source_data,
              "Source data"
            );
      const message2 =
        this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
          ? globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.object_data,
              "Object data"
            )
          : globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.reference,
              "Reference"
            );
      let { obj1, obj2 } = this.dataForObjectOrSource();
      let isUser = _.get(obj1, "Is User", null);
      if (isUser) {
        obj1 = _.omit(obj1, "Is User");
        obj1 = Object.assign({ "Your View?": isUser }, obj1);
      }
  
      let authNames = [];
      let authTitle = [];
      if(obj1)
      {
        {Object.keys(obj1).map((key) => (
          key == 'AuthorDetail' ? obj1[key].forEach((label, index)=> {
            authNames.push(
              <span class="value1" style={{marginBottom: '22px'}}>
                {label['firstname']} {label['lastname']}
              </span>
            );
            authTitle.push(
              <span class="value1" style={{marginBottom: '24px'}}>
                Author
              </span>
            );
            }) : ''
        ))}
      }
  
      return (
        <div className="ui container" id="infobar-object-info-modal">
          <div className="ui stackable grid">
            <div className="row">
              {object.type === globalFunctions.objectTypes.REFERENCE && (
                <div className="sixteen wide column">
                  <div className="record-table">
                    <div className="record">
                      <span className="key">View ID:</span>
                      <span className="value">{object.referenceData.viewId}</span>
                    </div>
                    <div className="record">
                      <span className="key">Title:</span>
                      <span className="value">{object.referenceData.title}</span>
                    </div>
                    <div className="record">
                      <span className="key">Value: </span>
                      <span className="value">{object.referenceData.value}</span>
                    </div>
                  </div>
                </div>
              )}
  
                <React.Fragment>
                  {object.type !== globalFunctions.objectTypes.REFERENCE && (
                    <div className="eight wide column">
                      <h4 className="infobar-object-info-header">{message1}</h4>
                      <div className="record-table">
                        {Object.keys(obj1).map((key) => (
                          <div key={key} className="record">
                            {/* <span className="key"> {key == 'Is Published' || key == 'Your View?' || key.length == 1 ? key.length == 1 ? 'Author' : '' : key} </span> */}
                            <span className="key" style={{display: 'inline-grid'}}> {key == 'Is Published' || key == 'Your View?' || key == 'Is Protected' || key == 'Highlight Height' ? '' : key == 'AuthorDetail' ? authTitle : key} </span>
                            <span className="value" style={{display: 'inline-grid'}}> { key == 'Is Published' || key == 'Your View?' || key == 'Is Protected' || key == 'Highlight Height' ? '' : key == 'AuthorDetail' ? authNames : obj1[key]} </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {object.type !== globalFunctions.objectTypes.REFERENCE && (
                    <div className="eight wide column">
                      <h4 className="infobar-object-info-header">{message2}</h4>
                      <div className="record-table">
                        {Object.keys(obj2).map((key) => (
                          <div key={key} className="record">
                            <span className="key"> {key} </span>
                            <span className="value"> {obj2[key]} </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </React.Fragment>
            </div>
          </div>
        </div>
      );
    }
  
    fullScreenOnNav() {
      var element = document.querySelector("#pusher-container");
          
      if(!document.getElementById("full-screen-icon").classList.contains('exit-fullscreen')) {
          // make the element go to full-screen mode
          element.requestFullscreen()
            .then(function() {
              // element has entered fullscreen mode successfully
              document.getElementById("full-screen-icon").src = window.location.href.substring(0,window.location.href.lastIndexOf('/') + 1)+"/img/exit_fullscreen.png";
              $("#full-screen-icon").removeClass("fullscreen").addClass("exit-fullscreen");
            })
            .catch(function(error) {
              // element could not enter fullscreen mode
            });
      } else if(document.getElementById("full-screen-icon").classList.contains('exit-fullscreen')) {   
          document.exitFullscreen();
          document.getElementById("full-screen-icon").src = window.location.href.substring(0,window.location.href.lastIndexOf('/') + 1)+ "/img/fullscreen.png";
          $("#full-screen-icon").removeClass("exit-fullscreen ").addClass("fullscreen");
      
        }
    }
  
    formatSourceObjectNotes() {
      
      const object = this.props.objectInfo;
      console.log('Notes');
      // console.log(object);
      // console.log(this.props.selectedObject);
      const message1 =
        this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
          ? globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.about_the_object,
              "About the object"
            )
          : globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.source_data,
              "Source data"
            );
      const message2 =
        this.props.objectInfo.type === globalFunctions.objectTypes.OBJECT
          ? globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.object_data,
              "Object data"
            )
          : globalFunctions.getTranslatedMessage(
              this.dataI18nKeys.reference,
              "Reference"
            );
      let { obj1, obj2 } = this.dataForObjectOrSource();
      let isUser = _.get(obj1, "Is User", null);
      if (isUser) {
        obj1 = _.omit(obj1, "Is User");
        obj1 = Object.assign({ "Your View?": isUser }, obj1);
      }
  
      return (
        <div className="ui container" id="infobar-object-info-modal">
          <div className="ui stackable grid">
            <div className="row">
              {object.type === globalFunctions.objectTypes.REFERENCE && (
                <div className="sixteen wide column">
                  <div className="record-table">
                    <div className="record">
                      <span className="key">View ID:</span>
                      <span className="value">{object.referenceData.viewId}</span>
                    </div>
                    <div className="record">
                      <span className="key">Title:</span>
                      <span className="value">{object.referenceData.title}</span>
                    </div>
                    <div className="record">
                      <span className="key">Value: </span>
                      <span className="value">{object.referenceData.value}</span>
                    </div>
                  </div>
                </div>
              )}
              {_.get(this.props.selectedObject, "type") === "SOURCE" ? (
                <div className="notesWrapper">
                  <div className="notesAuthorHeader">Notes from the author of this object:</div>
                  <div className="notes">{obj1.Notes || obj2.Notes || ""}</div>
                </div>
              ) : (
                <React.Fragment>
                  {object.type !== globalFunctions.objectTypes.REFERENCE && (
                    <div className="eight wide column">
                      <h4 className="infobar-object-info-header">{message1}</h4>
                      <div className="record-table">
                        {Object.keys(obj1).map((key) => (
                          <div key={key} className="record">
                            <span className="key"> {key} </span>
                            <span className="value"> { key == 'Is Published' ? obj1[key] == 'Published' ?  <button className="ui button green" id="publish-object">{obj1[key]}</button> : <button className="ui button blue" id="publish-object">{obj1[key]}</button> : obj1[key]} </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {object.type !== globalFunctions.objectTypes.REFERENCE && (
                    <div className="eight wide column">
                      <h4 className="infobar-object-info-header">{message2}</h4>
                      <div className="record-table">
                        {Object.keys(obj2).map((key) => (
                          <div key={key} className="record">
                            <span className="key"> {key} </span>
                            <span className="value"> {obj2[key]} </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      );
    }
  
    render() {
      const viewId =
        this.props.selectedObject ? this.props.selectedObject.viewId : '-';
      const headerViewId = viewId.replace(/\-/g,' - ');
      const id = this.props.selectedObject && this.props.selectedObject.id;
      const type = this.props.selectedObject && this.props.selectedObject.type;
      const disabled =
        this.props.selectedObject &&
        this.props.selectedObject.type === globalFunctions.objectTypes.SOURCE &&
        !this.props.selectedObject.hasNotes;
      const disabledChangeLog = this.props.changeLog.length ? false : true;
      const display = "show";
      const i18nStrChangeLog = globalFunctions.getTranslatedMessage(
        this.dataI18nKeys.change_log,
        "Change Log"
      );
      const i18nStrChangeLogHeader = globalFunctions.getTranslatedMessage(
        this.dataI18nKeys.change_log,
        "Change Log"
      ) + ' - '+ viewId;
  
      const i18nStrInfo = "Notes";
      const i18nStrHeader = 
          <div className="notesModalHeader ui grid">
            <p className="six wide column" >Notes</p>
            <p className="ten wide column" >{viewId}</p>
          </div> ;
  
      const i18nStrInfoText = globalFunctions.getTranslatedMessage(this.dataI18nKeys.info, "Info");
      const i18nStrInfoHeader = globalFunctions.getTranslatedMessage(this.dataI18nKeys.info, "Info");
  
      const isOwner = this.props.isOwner;
      const isSavedAsFavorite = this.props.isSavedAsFavorite;
      var isProtected = false;
      if (_.get(this.props.selectedObject, "isProtected", "no") === "yes") {
        isProtected = true;
      }
      var hideHeader = _.get(this.props, "selectedObject") !== null && 
                      type !== globalFunctions.objectTypes.END_POINT && 
                      type !== globalFunctions.objectTypes.OPEN_POINT;
  
      const isLoggedIn = this.props.isLoggedIn;
  
      var screenWidth = screen.width;
      var notes = this.props.selectedObject.hasNotes;
      // console.log(this.props.selectedObject);
      if(this.state.changeLogData.length > 0) {
        // document.getElementById('dropdown-color-change').style.color = "#0094ff";
        $('#dropdown-color-change').addClass('log-dot');
      } else {
        $('#dropdown-color-change').removeClass('log-dot');
      }
      
      if(notes == true) { 
        $('#dropdown-color-change').addClass('note-dot');
      } else {
        $('#dropdown-color-change').removeClass('note-dot');
      }
    
      return (
        <div
          id={this.domId}
          className={display + (_.get(this.props.selectedObject, "type") === "REFERENCE_NO" ? " page-menu" : "")}
          onClick={(e) => e.stopPropagation()}
        >
          {/* {screen.width > 700 && this.props.isLoggedIn && (
            <div id="selected-object-id_Scope" style={{cursor:'default'}}>
              <span className={`selected-object-id ${this.props.isPublished == 1 ? "green" : "blue"}`}>
                &nbsp;{this.props.isPublished == 1 ? "Public" : "Private"} &nbsp;
              </span>
            </div>
          ) || ''} */}
          <div id="selected-object-id" style={{cursor:'default', fontSize: screen.width < 426 ? 11: 9, background: 'transparent'}}>
            
            <div class = "ui dropdown testClass">
              <i class="dropdown icon" id = "dropdown-color-change"><span></span><span></span><span></span></i>
              {/* <span class="dropdown icon testIt" id = "dropdown-color-change"><span>.</span><span>.</span><span>.</span></span> */}
              <div class="menu menu2">
  
                {/* Info Menu item */}
                {/* <div class="item"> */}
                  <div class="item" id="selected-object-id_Info" onClick={(e) => this.props.showModal(i18nStrInfoHeader, this.formatObjectSourceInfo())}>
                    <span className="text">
                      {i18nStrInfoText}
                    </span>
                    {/* <i className="info icon"></i> */}
                  </div>
                {/* </div> */}
  
                {/* Notes item */}
                {_.get(this.props.selectedObject, "type") !== "REFERENCE" && _.get(this.props.selectedObject, "type") !== "REFERENCE_NO" && (
                  <div class="item" onClick={(e) => !disabled && _.get(this.props.selectedObject, "type") !== "OBJECT" ? this.props.showModal(i18nStrHeader, this.formatSourceObjectNotes()) : null }>
                      <div id="selected-object-id_Notes" style={{width: '75px'}} >
                        {_.get(this.props.selectedObject, "type") === "OBJECT" ? 
                          <span className="text disabled">
                            {i18nStrInfo}
                          </span>          
                          : 
                          <span className={`text${disabled ? " disabled" : ""}`}>
                            {notes == true ? <span class="yelloDotNote"></span> : ''}{i18nStrInfo}
                          </span>
                        }
                        {/* <i className="info icon"></i> */}
                      </div>
                  </div>
                )}
  
  
                {/* Share item */}
                {/* <div class="item"> */}
                  <div class="item" id="selected-object-id_Share" onClick={() => this.generateTinyURL(_.get(this.props.selectedObject, "viewId")) }>
                    <span className="text">Share</span>
                    {/* <i className="info icon"></i> */}
                  </div> 
                {/* </div> */}
  
                {/* Change log item */}
                {_.get(this.props.selectedObject, "type") !== "REFERENCE" && (
                  <div class="item" onClick={(e) => !disabledChangeLog ? this.props.showModal(i18nStrChangeLogHeader, this.formatChangeLog()) : null }>
                  
                    <div id="selected-object-id_ChangeLog" className="text" style={{width: '130px'}} >
                      <span className={`text${disabledChangeLog ? " disabled" : ""}`}>
                      <span>{this.state.changeLogData.length > 0 ? <span class="blueDotNote"></span> : ''}{i18nStrChangeLog}</span>
                      {/*<span style={{marginLeft:10,color:'white',backgroundColor: !disabledChangeLog ? '#FF4258' : '#404040',borderRadius:2}}>*/}
                      <span>
                        {/* <span style={{padding:2}} className={`text${disabledChangeLog ? " disabled" : ""}`}><sup style={{backgroundColor: !disabledChangeLog ? '#A0A0A0' : '#404040',borderRadius:2, padding: '4px'}}>{this.state.changeLogData.length}</sup></span> */}
                        <span style={{padding:2}} className={`text${disabledChangeLog ? " disabled" : ""}`}><sup style={{border: '1px solid', borderRadius:2, padding: '2px 4px 2px 4px', top: 0, left: '3px'}}>{this.state.changeLogData.length}</sup></span>
                      </span>
                      {/* <i className="clock icon"></i> */}
                      </span>
                    </div>
                  </div>
                )}
  
  
                {/* Favourite object item */}
                {screen.width > 700  && hideHeader && (
                <div class="item">
                    <div id="selected-object-save-as-favorite" onClick={ type === globalFunctions.objectTypes.OBJECT && !isOwner ? this.props.saveAsFavorite : () => undefined } className={ !isOwner && type === globalFunctions.objectTypes.OBJECT ? "show" : "hide" } >
                      <span className="text">
                        {isSavedAsFavorite
                          ? globalFunctions.getTranslatedMessage(
                              this.dataI18nKeys.saved_as_favorite,
                              "Saved as favorite"
                            )
                          : globalFunctions.getTranslatedMessage(
                              this.dataI18nKeys.save_as_favorite,
                              "Save as favorite"
                            )}
                      </span>
                      {isSavedAsFavorite ? (
                        <i className="heart icon"></i>
                      ) : (
                        <i className="heart outline icon"></i>
                      )}
                    </div>
                </div>
                )}
  
                {/* Edit item*/}
                {screen.width < 700 && this.props.isLoggedIn && (
                  <div class="item">
                    <div
                      // id="selected-object-id_EditMenu"
                      className={
                        (this.props.hideEdit || isProtected === true ? "hide" : "show",
                        (_.get(this.props.selectedObject, "pageSectionSelected") ||
                          _.get(this.props.selectedObject, "type") === "SOURCE" ||
                          _.get(this.props.selectedObject, "type") === "OBJECT") &&
                        isProtected === false &&
                        isOwner && isLoggedIn
                          ? "show editOptionInMenu"
                          : "hide")
                      }
                      onClick={this.props.fetchEditForm}
                    >
                      <span className="text">
                        {globalFunctions.getTranslatedMessage(
                          this.dataI18nKeys.edit,
                          "Edit"
                        )}
                      </span>
                      {/* <i className="edit icon"></i> */}
                    </div>
                  </div> 
                ) || ''}
  
                {/* Delete item */}
                {screen.width < 700 && this.props.isLoggedIn && (
                  <div class="item">
                      <div
                        id="selected-object-id_Delete2"
                        className={isOwner && isLoggedIn ? "show" : "hide"}
                        onClick={this.props.performDelete}
                      >
                        <span className="text">
                          {globalFunctions.getTranslatedMessage(
                            this.dataI18nKeys.delete,
                            "Delete"
                          )}
                        </span>
                        {/* <i className="trash icon"></i> */}
                      </div>
                  </div>
                ) || ''}
  
              </div>
            </div>
  
            {/* {viewId != '-' ?
              <span className="selected-object-id" data-tooltip= {viewId != '-' ? " Click to Copy" : ""} data-position="bottom center"  onClick={() => this.copyToClipboard(_.get(this.props.selectedObject, "viewId"))}>&nbsp; {headerViewId} &nbsp;</span>
            : 
              <span className="selected-object-id">&nbsp; {headerViewId} &nbsp;</span>
            } */}
            {/* {screen.width < 426 && hideHeader && (
              <i class="dropdown icon toggle-sidebar" id="header-dropdown-icon"
              style={{height:20,width:20,padding:5,marginLeft:3}} onClick={() => this.openNavHeader()}></i>
            )} */}
          </div> 
  
          {/* {screen.width > 700 && (
            <div class="remove-padding full-screen-mode item" onClick={() => this.fullScreenOnNav() }>
              <p id="full-screen-button" class="ui button">
                <img id="full-screen-icon" class="expand fullscreen" src={window.location.href.substring(0,window.location.href.lastIndexOf('/') + 1)+ "/img/fullscreen.png"}/>
              </p>
            </div>
          ) || ''} */}
      </div>
      );
    }
  }
  


// WEBPACK FOOTER //
// ./frontend/web/js/InfoBarHeaderMenu.js